import { RailVisitBulkEditViewStore } from '@planning/pages/RailVisit/stores/RailVisitBulkEditViewStore'
import { VesselVisitBulkEditViewStore } from '@planning/pages/VesselVisit/Stores/VesselVisitBulkEditViewStore'
import { useTranslate } from '@tolgee/react'
import { useCallback } from 'react'

export const useBulkEditAlertText = (
  viewStore: VesselVisitBulkEditViewStore | RailVisitBulkEditViewStore,
) => {
  const { t } = useTranslate()

  const getAlertText = useCallback(
    (direction: 'inbound' | 'outbound') => {
      const hasAtLeastTwoDifferentCarrierTypes =
        direction === 'inbound'
          ? viewStore.hasAtLeastTwoDifferentInboundCarrierTypes
          : viewStore.hasAtLeastTwoDifferentOutboundCarrierTypes

      if (!hasAtLeastTwoDifferentCarrierTypes) {
        return undefined
      }

      const countTranslations = []

      const unknownCount =
        direction === 'inbound' ? viewStore.inboundUnknownCount : viewStore.outboundUnknownCount
      const truckCount =
        direction === 'inbound' ? viewStore.inboundTruckCount : viewStore.outboundTruckCount
      const trainCount =
        direction === 'inbound' ? viewStore.inboundTrainCount : viewStore.outboundTrainCount
      const vesselCount =
        direction === 'inbound' ? viewStore.inboundVesselCount : viewStore.outboundVesselCount

      if (unknownCount) {
        countTranslations.push(
          `${t('bulkEditUnknownCount', '{count} unknown', { count: unknownCount })} `,
        )
      }

      if (truckCount) {
        countTranslations.push(
          `${t('bulkEditTruckCount', '{count} truck', { count: truckCount })} `,
        )
      }

      if (trainCount) {
        countTranslations.push(
          `${t('bulkEditTrainCount', '{count} train', { count: trainCount })} `,
        )
      }

      if (vesselCount) {
        countTranslations.push(
          `${t('bulkEditVesselCount', '{count} vessel', { count: vesselCount })} `,
        )
      }

      if (countTranslations.length) {
        return `${t(
          'bulkEditMultiCarrierTypeAlert',
          'Current selection includes the following carrier types:',
        )} ${countTranslations.join(', ')}`
      }
    },
    [t, viewStore],
  )

  const inboundAlertText = getAlertText('inbound')
  const outboundAlertText = getAlertText('outbound')

  return { inboundAlertText, outboundAlertText }
}
